module.exports = __webpack_public_path__ + "static/media/jne.199540db.png";